import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Student } from '../../../models/college-dashboard.model';

@Component({
  selector: 'app-readiness-profile-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './readiness-profile-modal.component.html',
  styleUrl: './readiness-profile-modal.component.scss'
})
export class ReadinessProfileModalComponent {
  @Input() student!: Student;
  @Output() close = new EventEmitter<void>();

  get classification(): string {
    if (this.student.score >= 80) return 'Ready';
    if (this.student.score >= 60) return 'Developing';
    return 'At Risk';
  }

  get scoreClass(): string {
    if (this.student.score >= 80) return 'ready-text';
    if (this.student.score >= 60) return 'developing-text';
    return 'needs-text';
  }

  get initials(): string {
    return this.student.name
      .split(' ')
      .map((part) => part[0])
      .join('')
      .substring(0, 2)
      .toUpperCase();
  }

  get strengthText(): string {
    return this.student.assessmentsCleared > 0
      ? 'Good assessment clearance rate.'
      : 'Consistent academic record.';
  }

  get weaknessText(): string {
    return this.student.profileComplete
      ? 'Interview performance could be improved.'
      : 'Profile is incomplete. Resume missing.';
  }

  get actionText(): string {
    return this.student.score >= 80
      ? 'Fast-track to premium job applications.'
      : 'Schedule 1-on-1 counseling session.';
  }
}
